import isNil from 'lodash/isNil';
import type { AnyDuringEslintMigration } from '../type/any';
import { AssertionError } from 'assert';

export default function assert(condition: unknown, msg?: string): asserts condition {
  if (!condition) {
    // TODO(collin.irwin): switch to just using a regular error. AssertionError is weird and causes weird error messages.
    throw new (AssertionError as AnyDuringEslintMigration)(msg);
  }
}

export function assertNotNil<T>(value: T | null | undefined, msg?: string): T {
  assert(!isNil(value), msg);
  return value;
}
